import { Box, Theme } from '@mui/material';
import { UserAuth } from 'store/auth';
import { useAppSelector } from 'store/hooks';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { Popup } from 'components/common/popup/Popup';

export default function MobilePagePopup(props: any) {
    const userAuth: UserAuth = useAppSelector((state) => state.auth);
    const [showPopup, setShowPopup] = useState<boolean>(true);
    const [mobilePageBannerHeight, setMobilePageBannerHeight] = useState<number>(0);

    const isAvailablePopup = userAuth.userInfo?.mobilePopupPage && isMobile;

    const updatePopupIndent = () => {
        const mobilePageBanner = document.querySelector('.mobile-page-banner');
        if (mobilePageBanner) {
            setMobilePageBannerHeight(mobilePageBanner.clientHeight);
        }
    };
    useEffect(() => {
        if (isAvailablePopup) {
            updatePopupIndent();
            window.addEventListener('resize', updatePopupIndent);
        }

        return () => {
            if (isAvailablePopup) {
                window.removeEventListener('resize', updatePopupIndent);
            }
        };
    }, []);

    if (!isAvailablePopup) return null;

    return (
        <Popup
            sx={{
                zIndex: (theme: Theme) => theme.zIndex.appBar + 5,
                '.MuiDialogContent-root': { borderTop: 0, p: 0 },
                '.popup__title': { display: 'none' },
                '.MuiBackdrop-root': { display: 'none' },
                '.MuiDialog-paper': {
                    marginTop: `${mobilePageBannerHeight}px`,
                    height: `calc(100% - ${mobilePageBannerHeight}px)`,
                    boxShadow: 'none',
                },
            }}
            fullScreen
            onHide={() => {
                setShowPopup(false);
            }}
            open={showPopup}
            settings={{
                noButtons: true,
            }}
        >
            <Box dangerouslySetInnerHTML={{ __html: userAuth.userInfo?.mobilePopupPage ?? '' }} />
        </Popup>
    );
}
